import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
// 路由配置列表
const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  // 面试测评
  {
    path: '/scanInterviewEntry',
    name: 'scanInterviewEntry',
    component: () => import('@/views/scanInterviewEntry'),
    // 不需要登录的时候，nologin设置为true
    meta: { nologin: true }
  },
  // 内推二维码背景图
  {
    path: '/myntbarcode',
    name: 'myntbarcode',
    component: () => import('@/views/myntbarcode/index.vue'),
    // 不需要登录的时候，nologin设置为true
    meta: { nologin: true }
  },
  // 绑定手机和openid
  {
    path: '/bindWXOpenid',
    name: 'bindWXOpenid',
    component: () => import('@views/bindWXOpenid/index.vue'),
    meta: { nologin: true }
  },
  // 扫码签到
  {
    path: '/scanSignIn',
    name: 'scanSignIn',
    component: () => import('@/views/scanSignIn/index.vue'),
    // 如果需要登录后重定向，设置为true
    meta: {
      redirect: true
    }
  },
  // 登录页
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/index.vue')
  },
  // 工作台首页路由
  {
    path: '/layout',
    name: 'layout',
    component: () => import('@/views/layout'),
    children: [
      {
        path: '/home',
        name: 'home',
        component: () => import('@/views/home'),
        meta: { keepAlive: true }
      }, // 查询界面
      {
        path: '/query',
        name: 'query',
        component: () => import('@/views/query/index.vue'),
        meta: { keepAlive: true }
      },
      // 申请界面
      {
        path: '/apply',
        name: 'apply',
        component: () => import('@/views/apply/index.vue'),
        meta: { keepAlive: true }
      },
      // 审批流打包界面（待审批，我发起，我已审批，被撤销的）
      {
        path: '/quickOpenApply',
        name: 'quickOpenApply',
        component: () => import('@/views/apply/quickOpenApply.vue'),
        meta: { keepAlive: true }
      },
      // 审批流查询，分类汇总界面
      {
        path: '/wfClass',
        name: 'wfClass',
        component: () => import('@/views/apply/wfClass.vue'),
        meta: { keepAlive: false }
      },
      // 审批流查询，列表界面
      {
        path: '/wfList',
        name: 'wfList',
        component: () => import('@/views/apply/wfList.vue'),
        meta: { keepAlive: false }
      },
      // 员工路由
      {
        path: '/staff',
        name: 'staff',
        component: () => import('@/views/staff'),
        meta: { keepAlive: true }
      },
      // 统计路由
      {
        path: '/statistics',
        name: 'statistics',
        component: () => import('@/views/statistics'),
        meta: { keepAlive: true }
      },
      // 个人中心路由
      {
        path: '/personCen',
        name: 'personCen',
        component: () => import('@/views/personCen'),
        meta: { keepAlive: true }
      },
      // 保留底部的跳转
      {
        path: '/jump',
        name: 'jump',
        component: () => import('@/views/jump/index.vue'),
        meta: { keepAlive: false }
      },
      // 报表
      {
        path: '/report',
        name: 'report',
        component: () => import('@/views/report/index.vue'),
        meta: { keepAlive: true }
      },
      // 报表条件
      {
        path: '/previewRp',
        name: 'previewRp',
        component: () => import('@/views/report/previewRp.vue'),
        meta: { keepAlive: false }
      }
    ]
  },
  // 保留底部的跳转-报表
  {
    path: '/jumpReport',
    name: 'jumpReport',
    component: () => import('@/views/jump/jumpReport.vue'),
    meta: { keepAlive: false }
  },
  // 待面试人员列表页面
  {
    path: '/toInterview',
    name: 'toInterview',
    component: () => import('@/views/toInterview')
  },
  // 面试测评--结果详情
  {
    path: '/interviewResults',
    name: 'interviewResults',
    component: () => import('@/views/toInterview/interviewCPresults.vue')
  },
  // 工资签收 - 密码
  {
    path: '/salarySiginPassword',
    name: 'salarySiginPassword',
    component: () => import('@/views/salarySigin/password.vue'),
    meta: { nologin: true }
  },
  // 工资签收 - 短信验证
  {
    path: '/smsVerification',
    name: 'smsVerification',
    component: () => import('@/views/salarySigin/smsVerification.vue')
  },
  // 工资签收 - 列表
  {
    path: '/salarySiginList',
    name: 'salarySiginList',
    component: () => import('@/views/salarySigin/list.vue'),
    meta: { nologin: true }
  },
  // 工资签收 - 每月
  {
    path: '/salaryMonth',
    name: 'salaryMonth',
    component: () => import('@/views/salarySigin/month.vue')
  },
  // 工资签收 - 详情
  {
    path: '/salaryDetails',
    name: 'salaryDetails',
    component: () => import('@/views/salarySigin/details.vue'),
    meta: { nologin: true }
  },
  // 公司日历
  {
    path: '/entCalendar',
    name: 'entCalendar',
    component: () => import('@/views/entCalendar/index.vue')
  },
  // 我的证件 - 列表页
  {
    path: '/MyIdCard',
    name: 'MyIdCard',
    component: () => import('@/views/MyIdCard/index.vue')
  },
  // 我的证件 - 添加页
  {
    path: '/addMyIdCard',
    name: 'addMyIdCard',
    component: () => import('@/views/MyIdCard/add.vue')
  },
  // 我的证件 - 详情页
  {
    path: '/myIdCardDetails',
    name: 'myIdCardDetails',
    component: () => import('@/views/MyIdCard/details.vue')
  },
  // 内推二维码
  {
    path: '/reqrcode',
    name: 'reqrcode',
    component: () => import('@/views/reqrcode')
  },
  // 依时利消费二维码
  {
    path: '/EastRiverQrcode',
    name: 'EastRiverQrcode',
    component: () => import('@/views/EastRiverQrcode')
  },
  // 待面试确认
  {
    path: '/confirmInterview',
    name: 'confirmInterview',
    component: () => import('@/views/confirmInterview')
  },
  // 待面试确认 - 个人信息
  {
    path: '/confirmInterviewInfo',
    name: 'confirmInterviewInfo',
    component: () => import('@/views/confirmInterviewInfo'),
    // 如果需要登录后重定向，设置为true
    meta: { redirect: true }
  },
  // 待转正确认
  {
    path: '/turningPositive',
    name: 'turningPositive',
    component: () => import('@/views/turningPositive'),
    // 如果需要登录后重定向，设置为true
    meta: { redirect: true }
  },
  // 待转正确认 - 个人信息
  {
    path: '/turningPositiveInfo',
    name: 'turningPositiveInfo',
    component: () => import('@/views/turningPositiveInfo')
  },
  // KPI待评价记录
  {
    path: '/jxDataSocre',
    name: 'jxDataSocre',
    component: () => import('@/views/jxDataSocre/index.vue'),
    // 如果需要登录后重定向，设置为true
    meta: { redirect: true }
  },
  // KPI待评价记录详情
  {
    path: '/jxDataSocreDetail',
    name: 'jxDataSocreDetail',
    component: () => import('@/views/jxDataSocre/detai.vue')
  },
  // 放弃入职
  {
    path: '/giveUpEntry',
    name: 'giveUpEntry',
    component: () => import('@/views/giveUpEntry')
  },
  // 面试者个人基本信息路由
  {
    path: '/viewInfo',
    name: 'viewInfo',
    component: () => import('@/views/viewInfo')
  },
  // 待入职人员列表页面
  {
    path: '/toInduction',
    name: 'toInduction',
    component: () => import('@/views/toInduction')
  },
  // 待入职者个人基本信息路由
  {
    path: '/inductionInfo',
    name: 'inductionInfo',
    component: () => import('@/views/inductionInfo')
  },
  // 面试淘汰页面路由
  {
    path: '/viewElimination',
    name: 'viewElimination',
    component: () => import('@/views/interviewEliminaton.vue')
  },
  // 简历筛选页面路由
  {
    path: '/resumeSel',
    name: 'resumeSel',
    component: () => import('@/views/resumeSelection.vue')
  },
  // 课程评价提交成功页
  {
    path: '/kcpjtjPage',
    name: 'kcpjtjPage',
    component: () => import('@/views/kcpjtjPage/index.vue')
  },
  // 课程评价提交成功页
  {
    path: '/kcpjtjResult',
    name: 'kcpjtjResult',
    component: () => import('@/views/kcpjtjResult/index.vue')
  },
  // 安排人员列表页面
  {
    path: '/arrangeInterview',
    name: 'arrangeInterview',
    component: () => import('@/views/arrangeInterview')
  },
  // 办理入职页面路由
  {
    path: '/applyEntry',
    name: 'applyEntry',
    component: () => import('@/views/applyEntry')
  },
  // 扫码入职
  {
    path: '/saoEntry',
    name: 'saoEntry',
    component: () => import('@/views/saoEntry')
  },
  // 面试通知
  {
    path: '/interviewNotice',
    name: 'interviewNotice',
    component: () => import('@/views/interviewNotice')
  },
  // 入职记录
  {
    path: '/entryRecord',
    name: 'entryRecord',
    component: () => import('@/views/entryRecord')
  },
  // 确认入职
  {
    path: '/confirmEntry',
    name: 'confirmEntry',
    component: () => import('@/views/confirmEntry')
  },
  // 选择岗位树
  {
    path: '/selStation',
    name: 'selStation',
    component: () => import('@/views/selStation')
  },
  // 测试控件
  {
    path: '/test',
    name: 'test',
    component: () => import('@/views/test')
  },
  // 发送offer
  {
    path: '/sendOffer',
    name: 'sendOffer',
    component: () => import('@/views/sendOffer')
  },
  // offer通知
  {
    path: '/offerNotice',
    name: 'offerNotice',
    component: () => import('@/views/offerNotice')
  },
  // 编辑入职信息
  {
    path: '/editOnboarding',
    name: 'editOnboarding',
    component: () => import('@/views/editOnboarding')
  },
  // 面试评价
  {
    path: '/viewEvaluate',
    name: 'viewEvaluate',
    component: () => import('@/views/viewEvaluate')
  },
  // 待考试
  {
    path: '/toExamined',
    name: 'toExamined',
    component: () => import('@/views/toExamined')
  },
  // 考试信息
  {
    path: '/examinInfo',
    name: 'examinInfo',
    component: () => import('@/views/examinInfo'),
    meta: { nologin: true }
  },
  // 待学习
  {
    path: '/toLearn',
    name: 'toLearn',
    component: () => import('@/views/toLearn')
  },
  // 公共课程
  {
    path: '/publicCourses',
    name: 'publicCourses',
    component: () => import('@/views/publicCourses')
  },
  // 学习课程
  {
    path: '/learningCourses',
    name: 'learningCourses',
    component: () => import('@/views/learningCourses')
  },
  // 学习课程
  {
    path: '/learningCoursesAndroid',
    name: 'learningCoursesAndroid',
    component: () => import('@/views/learningCourses/android.vue')
  },
  // 考试界面
  {
    path: '/examination',
    name: 'examination',
    component: () => import('@/views/examination'),
    meta: { nologin: true }
  },
  // 签到培训
  {
    path: '/signinTraining',
    name: 'signinTraining',
    component: () => import('@/views/signinTraining')
  },
  // 考试提交后的一个页面
  {
    path: '/submitPage',
    name: 'submitPage',
    component: () => import('@/views/submitPage'),
    meta: { nologin: true }
  },
  // 签到详情
  {
    path: '/registrationDetails',
    name: 'registrationDetails',
    component: () => import('@/views/registrationDetails')
  },

  // 答案解析界面
  {
    path: '/checkOutAnswer',
    name: 'checkOutAnswer',
    component: () => import('@/views/checkOutAnswer'),
    meta: { nologin: true }
  },

  // 培训报名
  {
    path: '/trainingRegister',
    name: 'trainingRegister',
    component: () => import('@/views/trainingRegister')
  },
  // 培训报名详情
  {
    path: '/signUpDetails',
    name: 'signUpDetails',
    component: () => import('@/views/signUpDetails')
  },
  // 培训报名结果
  {
    path: '/signUpSuccessfully',
    name: 'signUpSuccessfully',
    component: () => import('@/views/signUpSuccessfully')
  },
  // 待评价课程
  {
    path: '/toEvaluated',
    name: 'toEvaluated',
    component: () => import('@/views/toEvaluated')
  },
  // 培训记录备份
  {
    path: '/trainingRecord',
    name: 'trainingRecord',
    component: () => import('@/views/trainingRecord')
  },
  // 培训记录详情备份
  {
    path: '/trainingDetails',
    name: 'trainingDetails',
    component: () => import('@/views/trainingDetails')
  },
  // 培训记录
  {
    path: '/trainRecords',
    name: 'trainRecords',
    component: () => import('@/views/trainRecords/index.vue')
  },
  // 培训记录
  {
    path: '/trainRecordsDetails',
    name: 'trainRecordsDetails',
    component: () => import('@/views/trainRecordsDetails/index.vue')
  },
  // 待评价课程问卷
  {
    path: '/questionnaire',
    name: 'questionnaire',
    component: () => import('@/views/questionnaire')
  },
  // 培训协议
  {
    path: '/trainingAgreement',
    name: 'trainingAgreement',
    component: () => import('@/views/trainingAgreement')
  },

  //考试记录
  {
    path: '/examRecord',
    name: 'examRecord',
    component: () => import('@/views/examRecord')
  },
  // 考试记录已经审核后的详情
  {
    path: '/reviewedInfo',
    name: 'reviewedInfo',
    component: () => import('@/views/reviewedInfo')
  },

  // 绩效申诉
  {
    path: '/jxPerformanceAppeals',
    name: 'jxPerformanceAppeals',
    component: () => import('@/views/jxPerformanceAppeals'),
    // 如果需要登录后重定向，设置为true
    meta: { redirect: true }
  },

  // 绩效申诉--申诉详情
  {
    path: '/jxAppealsDetail',
    name: 'jxAppealsDetail',
    component: () => import('@/views/jxPerformanceAppeals/appeals.vue')
  },

  // 添加绩效申诉
  {
    path: '/jxAddPerformance',
    name: 'jxAddPerformance',
    component: () => import('@/views/jxAddPerformance')
  },
  // 我的考核表
  {
    path: '/jxMyAssessment',
    name: 'jxMyAssessment',
    component: () => import('@/views/jxMyAssessment')
  },
  // 我的考核表详情
  {
    path: '/jxMyAssessmentDetails',
    name: 'jxMyAssessmentDetails',
    component: () => import('@/views/jxMyAssessment/details.vue')
  },
  // 评价记录
  {
    path: '/jxEvaluationRecord',
    name: 'jxEvaluationRecord',
    component: () => import('@/views/jxEvaluationRecord')
  },

  // 评价记录详情
  {
    path: '/jxEvaluationRecordDetails',
    name: 'jxEvaluationRecordDetails',
    component: () => import('@/views/jxEvaluationRecord/details.vue')
  },

  // 评价人审核
  {
    path: '/jxAppraiserReview',
    name: 'jxAppraiserReview',
    component: () => import('@/views/jxAppraiserReview')
  },
  // 绩效-待评价记录
  {
    path: '/jxWhenMyAssesList',
    name: 'jxWhenMyAssesList',
    component: () => import('@/views/jxWhenMyAssesList')
  },
  // 绩效-待评价记录-详细
  {
    path: '/jxWhenMyAssesListDetail',
    name: 'jxWhenMyAssesListDetail',
    component: () => import('@/views/jxWhenMyAssesList/detail.vue')
  },
  // 绩效-待评价记录-详细-预览表格
  {
    path: '/jxWhenMyAssesListDetailTableDate',
    name: 'jxWhenMyAssesListDetailTableDate',
    component: () => import('@/views/jxWhenMyAssesList/tableDate.vue')
  },
  // 外网单点登录
  {
    path: '/Asclogin',
    name: 'Asclogin',
    component: () => import('@/views/Asclogin'),
    // 不需要登录的时候，nologin设置为true
    meta: { nologin: true }
  },
  // 外网单点登录
  {
    path: '/v8sso',
    name: 'v8sso',
    component: () => import('@/views/v8sso'),
    // 不需要登录的时候，nologin设置为true
    meta: { nologin: true }
  },
  // 外网单点登录2
  {
    path: '/faceCollectionSso',
    name: 'faceCollectionSso',
    component: () => import('@/views/faceCollectionSso'),
    // 不需要登录的时候，nologin设置为true
    meta: { nologin: true }
  },
  // 外网单点登录3
  {
    path: '/workFlowSso',
    name: 'workFlowSso',
    component: () => import('@/views/workFlow/index.vue'),
    // 不需要登录的时候，nologin设置为true
    meta: { nologin: true }
  },
  // 外网单点登录2
  {
    path: '/commSsoJump',
    name: 'commSsoJump',
    component: () => import('@/views/commSsoJump'),
    // 不需要登录的时候，nologin设置为true
    meta: { nologin: true }
  },
  // 工资签收页面的单点登录地址单点登录
  {
    path: '/salaryReceiptSso',
    name: 'salaryReceiptSso',
    component: () => import('@/views/salaryReceiptSso'),
    // 不需要登录的时候，nologin设置为true
    meta: { nologin: true }
  },
  // 皇派评价界面
  {
    path: '/HPKpi',
    name: 'HPKpi',
    component: () => import('@/views/HPKpi'),
    // 不需要登录的时候，nologin设置为true
    meta: { nologin: true }
  },
  // 忘记密码
  {
    path: '/ForgetPwd',
    name: 'ForgetPwd',
    component: () => import('@/views/ForgetPwd'),
    // 不需要登录的时候，nologin设置为true
    meta: { nologin: true }
  },
  // 修改密码
  {
    path: '/changePassword',
    name: 'changePassword',
    component: () => import('@/views/changePassword'),
    // 不需要登录的时候，nologin设置为true
    meta: { nologin: true }
  },

  // 我的考核指标
  {
    path: '/jxMyAssTarget',
    name: 'jxMyAssTarget',
    component: () => import('@/views/jxMyAssTarget')
  },
  // 我的考核指标--考核申请
  {
    path: '/jxMyAssTargetApply',
    name: 'jxMyAssTargetApply',
    component: () => import('@/views/jxMyAssTarget/application.vue')
  },
  // 我的考核指标--考核申请详情
  {
    path: '/jxMyAssTargetDetails',
    name: 'jxMyAssTargetDetails',
    component: () => import('@/views/jxMyAssTarget/details.vue')
  },
  // 我的考核指标--GS任务列表
  {
    path: '/myGsList',
    name: 'myGsList',
    component: () => import('@/views/jxMyAssTarget/myGsList.vue')
  },
  // 我的考核指标--GS任务列表--任务详情
  {
    path: '/myGsDetails',
    name: 'myGsDetails',
    component: () => import('@/views/jxMyAssTarget/myGsDetails.vue')
  },

  // 我的考核结果
  {
    path: '/jxMyAssResults',
    name: 'jxMyAssResults',
    component: () => import('@/views/jxMyAssResults')
  },
  // 我的考核结果--列表
  {
    path: '/jxMyAssResultsList',
    name: 'jxMyAssResultsList',
    component: () => import('@/views/jxMyAssResults/application.vue')
  },
  // 我的考核结果--考核结果详情
  {
    path: '/jxMyAssResultsAppeal',
    name: 'jxMyAssResultsAppeal',
    component: () => import('@/views/jxMyAssResults/appeal.vue')
  },

  // 我的考核结果--绩效申诉
  {
    path: '/jxMyAssResultsDetails',
    name: 'jxMyAssResultsDetails',
    component: () => import('@/views/jxMyAssResults/details.vue')
  },

  // 待审批指标
  {
    path: '/jxApprovalTag',
    name: 'jxApprovalTag',
    component: () => import('@/views/jxApprovalTag'),
    // 如果需要登录后重定向，设置为true
    meta: { redirect: true }
  },
  //待审批指标--同意/不同意
  {
    path: '/jxApprovalTagApply',
    name: 'jxApprovalTagApply',
    component: () => import('@/views/jxApprovalTag/application.vue')
  },
  //待审批指标--同意/不同意--详情
  {
    path: '/jxApprovalTagDetails',
    name: 'jxApprovalTagDetails',
    component: () => import('@/views/jxApprovalTag/details.vue')
  },

  // 新闻中心
  {
    path: '/newsCenter',
    name: 'newsCenter',
    component: () => import('@/views/newsCenter')
  },
  //  新闻中心--新闻详情
  {
    path: '/newsDetails',
    name: 'newsDetails',
    component: () => import('@/views/newsCenter/details.vue')
  },
  // 消息中心
  {
    path: '/msgCenter',
    name: 'msgCenter',
    component: () => import('@/views/msgCenter')
  },
  //  消息中心--消息详情
  {
    path: '/msgDetails',
    name: 'msgDetails',
    component: () => import('@/views/msgCenter/details.vue')
  },
  // 个人中心--个人资料
  {
    path: '/personalData',
    name: 'personalData',
    component: () => import('@/views/personalData')
  },

  // 修改工资密码
  {
    path: '/changeSalaryPsw',
    name: 'changeSalaryPsw',
    component: () => import('@/views/changeSalaryPsw'),
    // meta: { nologin: true }
    // 如果需要登录后重定向，设置为true
    meta: { redirect: true }
  },
  // 重置工资密码
  {
    path: '/resetSalaryPsw',
    name: 'resetSalaryPsw',
    component: () => import('@/views/resetSalaryPsw'),
    // meta: { nologin: true }
    // 如果需要登录后重定向，设置为true
    meta: { redirect: true }
  },
  // 绩效面谈
  {
    path: '/jxPerformanceInterview',
    name: 'jxPerformanceInterview',
    component: () => import('@/views/jxPerformanceInterview'),
    // 如果需要登录后重定向，设置为true
    meta: { redirect: true }
  },
  // 统计数据
  {
    path: '/jxStatisticalData',
    name: 'jxStatisticalData',
    component: () => import('@/views/jxStatisticalData/index.vue')
  },
  // 统计数据-列表
  {
    path: '/jxStatisticalDataList',
    name: 'jxStatisticalDataList',
    component: () => import('@/views/jxStatisticalData/list.vue')
  },
  // 统计数据-新增
  {
    path: '/jxStatisticalDataAdd',
    name: 'jxStatisticalDataAdd',
    component: () => import('@/views/jxStatisticalData/add.vue')
  },
  // 统计数据-详情
  {
    path: '/jxStatisticalDataDetails',
    name: 'jxStatisticalDataDetails',
    component: () => import('@/views/jxStatisticalData/details.vue')
  },
  // 绩效面谈--面谈详情
  {
    path: '/jxInterviewDetails',
    name: 'jxInterviewDetails',
    component: () => import('@/views/jxPerformanceInterview/interviews.vue')
  },
  // 扫码跳  通用问卷
  {
    path: '/generalQuestionnaire',
    name: 'generalQuestionnaire',
    component: () => import('@/views/generalQuestionnaire/index.vue'),
    // 如果需要登录后重定向，设置为true
    meta: { redirect: true }
  },
  // 绩效面谈--面谈详情
  {
    path: '/questionnaireSubmitted',
    name: 'questionnaireSubmitted',
    component: () => import('@/views/generalQuestionnaire/submitted.vue')
  },
  // 商店店铺签到界面
  {
    path: '/shopSignIn',
    name: 'shopSignIn',
    component: () => import('@/views/entSpecial/shopSignIn/index.vue')
  },
  // 会议预定
  {
    path: '/meetingReservation',
    name: 'meetingReservation',
    component: () => import('@/views/meetingReservation/index.vue')
  },
  // 会议预定
  {
    path: '/meetingReservationDetails',
    name: 'meetingReservationDetails',
    component: () => import('@/views/meetingReservation/details.vue')
  },
  // 佳成-设备保养
  {
    path: '/devBY',
    name: 'devBY',
    component: () => import('@/views/entSpecial/jiaCheng/devBY.vue')
  },
  // 佳成-设备维修记录
  {
    path: '/EquWh',
    name: 'EquWh',
    component: () => import('@/views/entSpecial/jiaCheng/EquWh.vue')
  },
  // 微信订餐
  {
    path: '/weChatOrdering',
    name: 'weChatOrdering',
    component: () => import('@/views/weChatOrdering/index.vue')
  },
  // 简易订餐
  {
    path: '/simple',
    name: 'simple',
    component: () => import('@/views/weChatOrdering/simple.vue')
  },
  // 简易订餐前-菜单
  {
    path: '/b4simple',
    name: 'b4simple',
    component: () => import('@/views/weChatOrdering/b4simple.vue')
  },
  // 厂车预约
  {
    path: '/facCarBook',
    name: 'facCarBook',
    component: () => import('@/views/facCarBook/index.vue')
  },
  // 扫码就餐
  {
    path: '/QrcodeAtteEntrSys',
    name: 'QrcodeAtteEntrSys',
    component: () => import('@/views/QrcodeAtteEntrSys/index.vue'),
    meta: { redirect: true }
  },
  // 查询--详情页面
  {
    path: '/commHrQueryPage',
    name: 'commHrQueryPage',
    component: () => import('@/views/commHrQueryPage/index.vue')
  },
  // 我的--人脸采集
  {
    path: '/faceCollection',
    name: 'faceCollection',
    component: () => import('@/views/faceCollection/index.vue')
  },
  // GS任务-下达任务/申请任务
  {
    path: '/ordTask',
    name: 'ordTask',
    component: () => import('@/views/GSTask/ordTask.vue')
  },
  // GS任务-任务审批
  {
    path: '/exaTask',
    name: 'exaTask',
    component: () => import('@/views/GSTask/exaTask.vue')
  },
  // GS任务-任务审批-详细
  {
    path: '/exaTaskApply',
    name: 'exaTaskApply',
    component: () => import('@/views/GSTask/exaTaskApply.vue')
  },
  // GS任务-任务提交
  {
    path: '/subTask',
    name: 'subTask',
    component: () => import('@/views/GSTask/subTask.vue')
  },
  // GS任务-任务提交-详细
  {
    path: '/subTaskApply',
    name: 'subTaskApply',
    component: () => import('@/views/GSTask/subTaskApply.vue')
  },
  // GS任务-任务评分
  {
    path: '/evaTask',
    name: 'evaTask',
    component: () => import('@/views/GSTask/evaTask.vue')
  },
  // GS任务-任务评分-详细
  {
    path: '/evaTaskApply',
    name: 'evaTaskApply',
    component: () => import('@/views/GSTask/evaTaskApply.vue')
  },
  // GS任务-任务查询
  {
    path: '/queTask',
    name: 'queTask',
    component: () => import('@/views/GSTask/queTask.vue')
  },
  // GS任务-任务查询-详细
  {
    path: '/queTaskApply',
    name: 'queTaskApply',
    component: () => import('@/views/GSTask/queTaskApply.vue')
  },
  // GS任务-评论
  {
    path: '/pfTask',
    name: 'pfTask',
    component: () => import('@/views/GSTask/pfTask.vue')
  },
  // GS任务-评论
  {
    path: '/pdfView',
    name: 'pdfView',
    component: () => import('@/views/pdfView/index.vue')
  },
  // 预入职外部跳转页面
  {
    path: '/preEntryOfferCheck',
    name: 'preEntryOfferCheck',
    component: () => import('@/views/preEntryOfferCheck'),
    // 不需要登录的时候，nologin设置为true
    meta: { nologin: true }
  },
  {
    path: '/trainPrjReqCheck',
    name: 'trainPrjReqCheck',
    component: () => import('@/views/trainPrjReqCheck'),
    // 不需要登录的时候，nologin设置为true
    meta: { nologin: true }
  },
  // 单点登录查看问卷调查
  {
    path: '/ssoCommPjDetail',
    name: 'ssoCommPjDetail',
    component: () => import('@/views/ssoCommPjDetail'),
    // 不需要登录的时候，nologin设置为true
    meta: { nologin: true }
  },
  // 查看问卷调查
  {
    path: '/queryCommPjDetail',
    name: 'queryCommPjDetail',
    component: () => import('@/views/ssoCommPjDetail/queryCommPjDetail.vue')
  },
  // 单点登录查看已完成试卷
  {
    path: '/ssoFinishPaper',
    name: 'ssoFinishPaper',
    component: () => import('@/views/ssoFinishPaper'),
    // 不需要登录的时候，nologin设置为true
    meta: { nologin: true }
  },
  // 查看已完成试卷
  {
    path: '/showFinishPaper',
    name: 'showFinishPaper',
    component: () => import('@/views/ssoFinishPaper/showFinishPaper.vue')
  },
  // 单点登录阅卷界面
  {
    path: '/ssoPaperTestAudit',
    name: 'ssoPaperTestAudit',
    component: () => import('@/views/ssoPaperTestAudit'),
    // 不需要登录的时候，nologin设置为true
    meta: { nologin: true }
  },
  // 单点登录在线考试
  {
    path: '/testlink',
    name: 'testlink',
    component: () => import('@/views/testLink'),
    // 不需要登录的时候，nologin设置为true
    meta: { nologin: true }
  },
  // 派工
  {
    path: '/dispatchingWorkers',
    name: 'dispatchingWorkers',
    component: () =>
      import('@/views/pieceManagement/dispatchingWorkers/index.vue'),
    meta: { keepAlive: true }
  },
  // 派工明细
  {
    path: '/dispatchingWorkersDetail',
    name: 'dispatchingWorkersDetail',
    component: () =>
      import('@/views/pieceManagement/dispatchingWorkers/detail.vue')
  },
  // 个人报工
  {
    path: '/jobBooking',
    name: 'jobBooking',
    component: () => import('@/views/pieceManagement/jobBooking/index.vue')
  },
  // 个人报工--自动掉落件报工
  {
    path: '/autoDropReporting',
    name: 'autoDropReporting',
    component: () =>
      import('@/views/pieceManagement/jobBooking/autoDropReporting.vue')
  },
  // 集体报工
  {
    path: '/groupJobBooking',
    name: 'groupJobBooking',
    component: () => import('@/views/pieceManagement/groupJobBooking/index.vue')
  },
  // 个人报工
  {
    path: '/chanXianPersonnel',
    name: 'chanXianPersonnel',
    component: () =>
      import('@/views/pieceManagement/chanXianPersonnel/index.vue')
  },
  // 审核
  {
    path: '/examine',
    name: 'examine',
    component: () => import('@/views/pieceManagement/examine/index.vue')
  },
  // 工作时长
  {
    path: '/workingHours',
    name: 'workingHours',
    component: () => import('@/views/pieceManagement/workingHours/index.vue'),
    meta: { keepAlive: true }
  },
  // 集体派工
  {
    path: '/dispatchingWorkersDetailJt',
    name: 'dispatchingWorkersDetailJt',
    component: () =>
      import('@/views/pieceManagement/dispatchingWorkers/jtDetail.vue')
  },
  // 工作时长-人员明细
  {
    path: '/personnelDetails',
    name: 'personnelDetails',
    component: () =>
      import('@/views/pieceManagement/workingHours/personnelDetails.vue')
  },
  // 注塑登记
  {
    path: '/zsCheckIn',
    name: 'zsCheckIn',
    component: () => import('@/views/pieceManagement/zsCheckIn/index.vue')
  },
  // 总装登记
  {
    path: '/zzCheckIn',
    name: 'zzCheckIn',
    component: () => import('@/views/pieceManagement/zzCheckIn/index.vue')
  },
  // 待办事项
  {
    path: '/toDoList',
    name: 'toDoList',
    component: () => import('@/views/pieceManagement/toDoList/index.vue')
  },
  // 喷粉1登记
  {
    path: '/toPenFen1',
    name: 'toPenFen1',
    component: () => import('@/views/pieceManagement/toPenFen1/index.vue')
  },
  // 喷粉2登记
  {
    path: '/toPenFen2',
    name: 'toPenFen2',
    component: () => import('@/views/pieceManagement/toPenFen2/index.vue')
  },
  // 五金登记
  {
    path: '/toWuJin',
    name: 'toWuJin',
    component: () => import('@/views/pieceManagement/toWuJin/index.vue'),
    meta: { redirect: true }
  },
  // 培训实施推送报名
  {
    path: '/trainImpReqCheck',
    name: 'trainImpReqCheck',
    component: () => import('@/views/trainImpReqCheck'),
    // 不需要登录的时候，nologin设置为true
    meta: { nologin: true }
  },
  // 审批流
  {
    path: '/workFlow',
    name: 'workFlow',
    component: () => import('@/views/workFlow/index.vue'),
    meta: {
      redirect: true
      // , nologin: true
    }
  },
  // 排班设置
  {
    path: '/schedulingSettings',
    name: 'schedulingSettings',
    component: () => import('@/views/schedulingSettings/index.vue')
  },
  // 水电抄数
  {
    path: '/meterReading',
    name: 'meterReading',
    component: () => import('@/views/meterReading/index.vue'),
    meta: { redirect: true }
  },
  // 水电抄数-详情
  {
    path: '/meterReadDetail',
    name: 'meterReadDetail',
    component: () => import('@/views/meterReading/detail.vue'),
    meta: { redirect: true }
  },
  // 斯凯奇-报工登录
  {
    path: '/skqlogin',
    name: 'skqlogin',
    component: () => import('@/views/entSpecial/sikaiqi/login.vue'),
    // 不需要登录的时候，nologin设置为true
    meta: { nologin: true }
  },
  // 斯凯奇-报工卡
  {
    path: '/skqcard',
    name: 'skqcard',
    component: () => import('@/views/entSpecial/sikaiqi/card.vue'),
    // 不需要登录的时候，nologin设置为true
    meta: { nologin: true }
  },
  // 斯凯奇-入职筛选
  {
    path: '/skxRzsx',
    name: 'skxRzsx',
    component: () => import('@/views/entSpecial/sikaiqi/skxRzsx.vue')
  },
  // 任职资格查询
  {
    path: '/viewMyRzzg',
    name: 'viewMyRzzg',
    component: () => import('@/views/viewMyRzzg/index.vue')
  },
  // 移动签到
  {
    path: '/phonesign',
    name: 'phonesign',
    component: () => import('@/views/phonesign/index.vue')
  },
  // 移动签到测试页面
  {
    path: '/phonesigntest',
    name: 'phonesigntest',
    component: () => import('@/views/phonesign/test.vue'),
    // 不需要登录的时候，nologin设置为true
    meta: { nologin: true }
  },
  // 人工智能
  {
    path: '/hyAichat',
    name: 'topLevelHyAiZhuShowChat',
    component: () => import('@/views/hyAi/index.vue'),
    meta: { keepAlive: false }
  },
  // 工资签收外部跳转
  {
    path: '/salaryReceipt',
    name: 'salaryReceipt',
    component: () => import('@/views/salarySigin/salaryReceipt.vue'),
    meta: { nologin: true }
  },
  {
    path: '/lke',
    name: 'lke',
    component: () => import('@/views/lke/index.vue'),
    meta: { nologin: true }
  },
  // 活动报名
  {
    path: '/eventRegistration',
    name: 'eventRegistration',
    component: () =>
      import('@/views/integralActivities/eventRegistration/index.vue')
  },
  // 活动详情
  {
    path: '/eventDetails',
    name: 'eventDetails',
    component: () => import('@/views/integralActivities/eventDetails/index.vue')
  },
  // 活动签到
  {
    path: '/eventSignIn',
    name: 'eventSignIn',
    component: () => import('@/views/integralActivities/eventSignIn/index.vue')
  },
  // 积分查询
  {
    path: '/pointsInquiry',
    name: 'pointsInquiry',
    component: () =>
      import('@/views/integralActivities/pointsInquiry/index.vue')
  },
  // 积分排名
  {
    path: '/pointsRanking',
    name: 'pointsRanking',
    component: () =>
      import('@/views/integralActivities/pointsInquiry/pointsRanking.vue')
  },
  // 积分兑换
  {
    path: '/pointsExchange',
    name: 'pointsExchange',
    component: () =>
      import('@/views/integralActivities/pointsExchange/index.vue')
  },
  // 商品详情
  {
    path: '/goodsDetails',
    name: 'goodsDetails',
    component: () =>
      import('@/views/integralActivities/pointsExchange/goodsDetails.vue')
  },
  // 我的订单
  {
    path: '/myOrders',
    name: 'myOrders',
    component: () => import('@/views/integralActivities/myOrders/index.vue')
  },
  // 兑换清单
  {
    path: '/productExChangeCode',
    name: 'productExChangeCode',
    component: () =>
      import('@/views/integralActivities/myOrders/productExChangeCode.vue'),
    meta: { redirect: true }
  },
  // 流程委托
  {
    path: '/processDelegation',
    name: 'processDelegation',
    component: () => import('@/views/processDelegation/index.vue')
  },
  {
    path: '/zbcsPath',
    name: 'zbcsPath',
    component: () => import('@/views/zbcsPath/index.vue')
  },
  // 自定义二维码
  {
    path: '/showCustomBarCode',
    name: 'showCustomBarCode',
    component: () => import('@/views/showCustomBarCode/index.vue')
  },
  // 通讯录
  {
    path: '/addressBook',
    name: 'addressBook',
    component: () => import('@/views/addressBook/index.vue')
  },
  // 待阅卷
  {
    path: '/paperTestAudit',
    name: 'paperTestAudit',
    component: () => import('@/views/paperTestAudit/index.vue')
  },
  // 宿舍房态图
  {
    path: '/viewLivingQuartersChart',
    name: 'viewLivingQuartersChart',
    component: () => import('@/views/viewLivingQuartersChart/index.vue'),
    meta: { redirect: true }
  },
  // 固定资产盘点
  {
    path: '/fixedAssetInventory',
    name: 'fixedAssetInventory',
    component: () => import('@/views/fixedAssetInventory/index.vue')
  },
  // 固定资产盘点明细
  {
    path: '/fixedAssetInventoryDetail',
    name: 'fixedAssetInventoryDetail',
    component: () => import('@/views/fixedAssetInventory/detail.vue')
  },
]
// history 使用历史模式打包
// hash 使用hash模式打包
// 如果客户需求，打包使用同端口的，执行指令npm run port
// 如果客户需求，使用历史模式打包一份v8h5，把router下的index.js的new VueRouter的mode改为history，然后npm run build
// 其它情况，直接使用npm run build打包
const router = new VueRouter({
  mode: 'history', //history hash
  // base:process.env.BASE_URL,
  routes
})
export default router
